import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _adminWarned;
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { registerDeprecationHandler } from "@ember/debug";
import Service, { service } from "@ember/service";
import { addGlobalNotice } from "discourse/components/global-notice";
import identifySource from "discourse/lib/source-identifier";
import { escapeExpression } from "discourse/lib/utilities";
import { registerDeprecationHandler as registerDiscourseDeprecationHandler } from "discourse-common/lib/deprecated";
import { bind } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";

// Deprecations matching patterns on this list will trigger warnings for admins.
// To avoid 'crying wolf', we should only add values here when we're sure they're
// not being triggered by core or official themes/plugins.
export const CRITICAL_DEPRECATIONS = [/^discourse.modal-controllers$/, /^discourse.bootbox$/, /^(?!discourse\.)/ // All unsilenced ember deprecations
];

// Deprecation handling APIs don't have any way to unregister handlers, so we set up permenant
// handlers and link them up to the application lifecycle using module-local state.
let handler;
registerDeprecationHandler((message, opts, next) => {
  handler?.(message, opts);
  return next(message, opts);
});
registerDiscourseDeprecationHandler((message, opts) => handler?.(message, opts));
let DeprecationWarningHandler = (_class = (_adminWarned = /*#__PURE__*/new WeakMap(), class DeprecationWarningHandler extends Service {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _classPrivateFieldInitSpec(this, _adminWarned, false);
    handler = this.handle;
  }
  willDestroy() {
    handler = null;
  }
  handle(message, opts) {
    const workflowConfigs = window.deprecationWorkflow?.config?.workflow;
    const matchingConfig = workflowConfigs.find(config => config.matchId === opts.id);
    if (matchingConfig && matchingConfig.handler === "silence") {
      return;
    }
    const source = identifySource();
    if (source?.type === "browser-extension") {
      return;
    }
    this.maybeNotifyAdmin(opts, source);
  }
  maybeNotifyAdmin(opts, source) {
    if (_classPrivateFieldGet(_adminWarned, this)) {
      return;
    }
    if (!this.currentUser?.admin) {
      return;
    }
    if (!this.siteSettings.warn_critical_js_deprecations) {
      return;
    }
    if (CRITICAL_DEPRECATIONS.some(pattern => pattern.test(opts.id))) {
      this.notifyAdmin(opts, source);
    }
  }
  notifyAdmin(_ref, source) {
    let {
      id,
      url
    } = _ref;
    _classPrivateFieldSet(_adminWarned, this, true);
    let notice = I18n.t("critical_deprecation.notice") + " ";
    if (url) {
      notice += I18n.t("critical_deprecation.linked_id", {
        id: escapeExpression(id),
        url: escapeExpression(url)
      });
    } else {
      notice += I18n.t("critical_deprecation.id", {
        id: escapeExpression(id)
      });
    }
    if (this.siteSettings.warn_critical_js_deprecations_message) {
      notice += " " + this.siteSettings.warn_critical_js_deprecations_message;
    }
    if (source?.type === "theme") {
      notice += " " + I18n.t("critical_deprecation.theme_source", {
        name: escapeExpression(source.name),
        path: source.path
      });
    } else if (source?.type === "plugin") {
      notice += " " + I18n.t("critical_deprecation.plugin_source", {
        name: escapeExpression(source.name)
      });
    }
    addGlobalNotice(notice, "critical-deprecation", {
      dismissable: true,
      dismissDuration: moment.duration(1, "day"),
      level: "warn"
    });
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handle", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "handle"), _class.prototype)), _class);
export { DeprecationWarningHandler as default };